/* eslint-disable */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { WidgetHeader } from '../widgetHeader.jsx';
import { getWidgetHeaderText } from '../../../common/utilities/getWidgetHeaderUtil';

/**
 * List of widgets types that are required to have their links point to the localized version of the pages.
 * 
 * Note: not all widget types listed here follow this HOC pattern with asWidget to render the UI e.g Fire, Camera & WeatherCamera widgets.
 * Generic Types like Link and LifestyleIndex are what we are primarily targetting here.
 */
const localizedWidgetTypes = [
    'LifestyleIndex',
    'Link',
    'Fire',
    'Camera',
    'WeatherCamera'
];

export function asWidget(WrappedComponent)
{
    const widgetStyles = {
        widgetContainer: {
            height: 250
            , width: '100%'
            , color: '#000000'
            , cursor: 'pointer'
            , borderRadius: '2px'
        }
        , widgetArrow: {
            position: 'absolute'
            , top: '50%'
            , left: '50%'
            , marginTop: '-3px'
            , marginLeft: '-5px'
            , fill: '#666'
            , strokeWidth: '1px'
            , stroke: '#666'
            , width: '10px'
            , height: '6px'
        }
        , widgetAsLink: {
            display: 'block'
            , textDecoration: 'none'
            , cursor: 'pointer'
        }
    };

    const wrappedComponentName = (
        WrappedComponent.displayName
        || WrappedComponent.name
        || 'Component'
    );

    class Widget extends Component
    {
        static displayName = `asWidget(${wrappedComponentName})`;

        static propTypes = {
            displayArrow: PropTypes.bool
            , headerText: PropTypes.string
            , linkUrl: PropTypes.string
            , widgetType: PropTypes.string.isRequired
            , activeLocationSlugname: PropTypes.string
            , cityName: PropTypes.string
            , stateAbbreviation: PropTypes.string
            , isHurricaneSectionEnabled: PropTypes.bool,
            pressureUnit: PropTypes.number,
            windUnit: PropTypes.number
        };

        static defaultProps = {
            displayArrow: true
        };

        constructor(props)
        {
            super(props);

            this.state = {

            };
        }

        render()
        {
            const {
                displayArrow
                , headerText
                , linkUrl
                , widgetType
                , activeLocationSlugname = ''
                , widget
                , stateAbbreviation
                , cityName
                , isHurricaneSectionEnabled,
                pressureUnit,
                windUnit
                , ...wrappedComponentProps
            } = this.props;

            
            let widgetHeaderText = getWidgetHeaderText({widgetTitle: headerText});
            if (cityName && stateAbbreviation && localizedWidgetTypes.includes(widgetType)) {
                widgetHeaderText = getWidgetHeaderText({widgetTitle: headerText, cityName, stateAbbreviation});
            }

            /**
             * TODO: WIP: Clean up logic after New Hurricane feature is deployed
             * We just just making sure the href points to the new hurricane page when feature flag is on.
             */
            let widgetBaseLinkURL = linkUrl;
            const isHurricanePage = linkUrl.includes('alerts/hurricane/');
            const isPollenPage = linkUrl.includes('life/pollen');
            const isColdFluPage = linkUrl.includes('life/cold-flu');
            if (isHurricaneSectionEnabled && widgetType === 'Link' && isHurricanePage) {
                widgetBaseLinkURL = `hurricane/active?su=${windUnit}&pu=${pressureUnit}`;
            }

            const hasLink          = widgetBaseLinkURL && !widgetBaseLinkURL.isNullOrWhiteSpace();
            const hasHeaderText    = headerText && !headerText.isNullOrWhiteSpace();
            const widgetLocalizedURL = widgetBaseLinkURL 
                && activeLocationSlugname
                && localizedWidgetTypes.includes(widgetType)
                && !isHurricanePage
                ? `${widgetBaseLinkURL}${activeLocationSlugname}` 
                : widgetBaseLinkURL;

            const widgetHeader = !hasHeaderText
                ? null
                : (
                    <WidgetHeader headerText={widgetHeaderText} iconStyle={{transform: 'rotate(-90deg)'}}>
                        { displayArrow && <svg style={widgetStyles.widgetArrow}>
                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                viewBox="0 0 9.9 5.1" enableBackground="new 0 0 9.9 5.1" xmlSpace="preserve">
                                <g>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M4.4,4.3L9,0.1C9.2,0,9.4,0,9.6,0.1l0.3,0.2c0.1,0.1,0.1,0.3,0,0.5L5.2,5
                                                    C5.1,5.1,4.8,5.1,4.7,5L4.4,4.8C4.3,4.6,4.3,4.4,4.4,4.3L4.4,4.3z"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M0.4,0.1C0.5,0,0.8,0,0.9,0.1l4.6,4.2c0.1,0.1,0.1,0.3,0,0.5L5.2,5
                                                    C5.1,5.1,4.8,5.1,4.7,5L0.1,0.8C0,0.7,0,0.5,0.1,0.3L0.4,0.1L0.4,0.1L0.4,0.1z"/>
                                </g>
                            </svg>
                        </svg> }
                    </WidgetHeader>
                )
            ;

            const wrappedComponentView = (<WrappedComponent {...this.props} />);
            const widgetView = (
                <Fragment>
                    { widgetHeader }
                    { wrappedComponentView }
                </Fragment>
            );

            const renderAsWidget = () => {
                if (hasLink && (isHurricanePage || isPollenPage || isColdFluPage)) {
                    return <a href={widgetLocalizedURL} style={widgetStyles.widgetAsLink} target='_self'>{ widgetView }</a>;
                }
                if (hasLink && !isHurricanePage && !isColdFluPage) {
                    return <a href={widgetLocalizedURL} style={widgetStyles.widgetAsLink}>{ widgetView }</a>;
                }
                return { widgetView };
            }

            return (renderAsWidget());
        }
    }

    Widget.displayName = `asWidget(${wrappedComponentName})`;

    return hoistNonReactStatics(Widget, WrappedComponent);
}

